import React, {Fragment, useEffect, useMemo, useState} from 'react';
import axios from "axios";
import styles from './openness.module.scss';
import CountryFlag from '../common/countryFlag-openness/country-flag-openness';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';
import { rankSuffix } from "../../utils/utils";
import LoadingSpinner from '../common/loading/LoadingSpinner';

const options = [
    {label: "Openness score (out of 198)", value: "opennessScore"},
    {label:"Rank in Africa", value:"rank"},
    {label: "Openness %", value: "opennessPercentage"},
];


const Openness = () => {
    const [sortColumn, setSortColumn] = useState('opennessScore');
    const [display, setDisplay] = useState();
    const [loading, setLoading] = useState(true);
    const [opennessData, setOpennessData] = useState(null);
    const [rankCount, setRankCount] = useState(1);
    const [scoreCount, setScoreCount] = useState(-1);
    const [percentageCount, setPercentageCount] = useState(-1);
    // const data_url = process.env.REACT_APP_HENLEY_API_OPENNESS_PATH;

    useEffect(() => {
      const fetchData = async () => {
        try {
          const requestData  = await axios.get(process.env.REACT_APP_HENLEY_API_OPENNESS_PATH);
          setOpennessData(requestData.data);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
      
      fetchData();
    }, []);
    
    const reverseSortNum = (data, columnName, count) => {
      if (count === -1) {
        return data.sort((a, b) => b[columnName] - a[columnName] || (a.country.toUpperCase()).localeCompare(b.country.toUpperCase()));
      }
      return data.sort((a, b) => a[columnName] - b[columnName] || (a.country.toUpperCase()).localeCompare(b.country.toUpperCase()));
    }
    
    const handleSortingOptions = (data, sortColumn) =>{
        switch (sortColumn) {
          case 'rank':
            return reverseSortNum(data, sortColumn, rankCount);
          case 'opennessScore':
            return reverseSortNum(data, sortColumn, scoreCount);
          case 'opennessPercentage':
            return reverseSortNum(data, sortColumn, percentageCount);
          default:
            break;
        }
    }
 


    const handleOptionSelect = (option) => {
        // setSelectedOption(option);
        setSortColumn(option.value);
    };

    const handleSort = (columnName) => {
        switch (columnName) {
          case 'rank':
            (rankCount === 1) ? setRankCount(-1) : setRankCount(1);
            break;
          case 'opennessScore':
            (scoreCount === 1) ? setScoreCount(-1) : setScoreCount(1);
            break;
          case 'opennessPercentage':
            (percentageCount === 1) ? setPercentageCount(-1) : setPercentageCount(1);
            break;
          default:
            break;
        }
      
        setSortColumn(columnName);
    };
    
    // sort the data based on the `sortColumn` value
    const data = useMemo(() => {
    
        const africaData = (opennessData === null) ? null : opennessData.filter((t) => t.region === 'AFRICA');
        let setOfScore = [];
        if (africaData) {
          setOfScore = [...new Set(africaData.map(c => c.opennessScore))].sort((a, b) => b - a);
          africaData.map((c) => {
            c.rank = setOfScore.indexOf(c.opennessScore) + 1;
            
          })
        }
        

        return (africaData === null) ? null : africaData.sort((a, b) => a.rank - b.rank).filter((a) => a.rank < 21);
        
    }, [opennessData]);
    
    

    const handleMobileRowClick = (index) => {
        setDisplay(index);
    }
    
    // const sortedData = sortColumn
    //                   ? handleSortingOptions(data, sortColumn)
    //                   : data;
    
    
    if (loading) return <LoadingSpinner />;

    return (
        <>
            {/* <h3 className="mb-5">Africa's Top 20 Passports on the Henley Openness Index</h3> */}
            <div className={`d-md-none ${styles.sortMobileWrapper}`}>
                <div className={styles.sortTitle}>Sort by</div>
                <SelectDropdown options={options} onSelect={handleOptionSelect}/>
            </div>
            <table className={`chartTable ${styles.overviewChartTable} ${styles.opennessChartTable}`}>
                <thead>
              
                <tr>
                    <th className={styles.cityColumn} >Country</th>

                    <th
                      className={
                        `text-left 
                                      ${styles.cellHideMobile}
                                      ${styles.sortableColumn} 
                                      ${styles.dataColumn}
                                      ${sortColumn === 'rank' ? styles.selectedColumn : ''}
                                      ${sortColumn === 'rank' ? styles.displayColumnTitleDiv : ''}
                      `}
                      onClick={() => handleSort("rank")}
                    >
                      <div className={styles.sortColumnTitle}>
                        <span className={styles.sortColumnTitleText}>Rank in Africa</span>
                        {(rankCount === -1) ? <ReverseIconSort /> : <IconSort />}
                      </div>
                    </th>
                    <th
                      className={
                        `text-right 
                                      ${styles.cellHideMobile}
                                      ${styles.sortableColumn} 
                                      ${styles.dataColumn}
                                      ${sortColumn === 'opennessScore' ? styles.selectedColumn : ''}
                                      ${sortColumn === 'opennessScore' ? styles.displayColumnTitleDiv : ''}
                      `}
                      onClick={() => handleSort("opennessScore")}
                    >
                      <div className={styles.sortColumnTitle}>
                        <span className={styles.sortColumnTitleText}>Openness score<br/>(out of 198)</span>
                        {(scoreCount === 1) ? <ReverseIconSort /> : <IconSort />}
                      </div>
                    </th>
                    <th
                      className={
                        `text-right 
                                      ${styles.cellHideMobile}
                                      ${styles.sortableColumn} 
                                      ${styles.dataColumn}
                                      ${sortColumn === 'opennessPercentage' ? styles.selectedColumn : ''}
                                      ${sortColumn === 'opennessPercentage' ? styles.displayColumnTitleDiv : ''}
                      `}
                      onClick={() => handleSort("opennessPercentage")}
                    >
                      <div className={styles.sortColumnTitle}>
                        <span className={styles.sortColumnTitleText}>Openness %</span>
                        {(percentageCount === 1) ? <ReverseIconSort /> : <IconSort />}
                      </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                {data !== null && (sortColumn ? handleSortingOptions(data, sortColumn) : data).map((item, index) => (
                    <Fragment key={index}>
                        <tr onClick={() => handleMobileRowClick(index)}
                            className={`${styles.contentRow}`}>
                            <td className={styles.cellCountry}>
                              <CountryFlag iso={item.iso} country={item.country}/>

                            </td>
                            <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'rank' ? styles.selectedColumn : ''}`}>
                                {rankSuffix(item.rank)}
                            </td>
                            <td className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'opennessScore' ? styles.selectedColumn : ''}`}>
                                {item.opennessScore}
                            </td>
                            <td className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'opennessPercentage' ? styles.selectedColumn : ''}`}>
                                {Math.round(item.opennessPercentage) + '%'}
                            </td>
                        </tr>

                    </Fragment>
                ))}
                </tbody>
              
            </table>
            <div className="footer-note mt-5">
              <p>Source: Henley Openness Index</p>
            </div>
        </>
    )
}

export default Openness;